import React, { useState, useEffect } from 'react';
import { useI18n } from '../../i18n/I18nContext';
import api from '../../utils/api';

function VendorSettings() {
  var i18n = useI18n();
  var t = i18n.t;

  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];

  var savingState = useState(false);
  var saving = savingState[0];
  var setSaving = savingState[1];

  var settingsState = useState({
    native_language: 'en',
    target_language: 'th',
    language_display_mode: 'dual',
    default_fine_print: '',
    default_website_url: '',
    default_whatsapp: '',
    default_line_url: '',
    default_phone: ''
  });
  var settings = settingsState[0];
  var setSettings = settingsState[1];

  var languagesState = useState([]);
  var languages = languagesState[0];
  var setLanguages = languagesState[1];

  var messageState = useState(null);
  var message = messageState[0];
  var setMessage = messageState[1];

  useEffect(function() {
    loadSettings();
  }, []);

  function loadSettings() {
    api.get('/vendor/settings')
      .then(function(data) {
        setSettings(data.settings);
        setLanguages(data.supported_languages || []);
        setLoading(false);
      })
      .catch(function(err) {
        console.error('Failed to load settings:', err);
        setLoading(false);
      });
  }

  function handleChange(field, value) {
    setSettings(function(prev) {
      var updated = Object.assign({}, prev);
      updated[field] = value;
      return updated;
    });
  }

  function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setMessage(null);

    api.put('/vendor/settings', settings)
      .then(function() {
        setMessage({ type: 'success', text: 'Settings saved successfully' });
        setSaving(false);
      })
      .catch(function(err) {
        setMessage({ type: 'error', text: err.message || 'Failed to save settings' });
        setSaving(false);
      });
  }

  function handleApplyToAll() {
    if (!window.confirm('Apply your default templates to all your offers? This will overwrite any custom values that are set to use defaults.')) {
      return;
    }

    setSaving(true);
    api.post('/vendor/settings/apply-to-all', {})
      .then(function(data) {
        setMessage({ type: 'success', text: 'Defaults applied to ' + data.offers_updated + ' offers' });
        setSaving(false);
      })
      .catch(function(err) {
        setMessage({ type: 'error', text: err.message || 'Failed to apply defaults' });
        setSaving(false);
      });
  }

  if (loading) {
    return React.createElement('div', { className: 'flex justify-center', style: { padding: '40px' } },
      React.createElement('div', { className: 'spinner' })
    );
  }

  return React.createElement('div', null,
    React.createElement('h1', { style: { fontSize: '24px', fontWeight: '600', marginBottom: '24px' } }, 
      t('vendor.settings') || 'Settings'
    ),

    message && React.createElement('div', {
      className: 'card',
      style: {
        marginBottom: '16px',
        padding: '12px 16px',
        background: message.type === 'success' ? '#d4edda' : '#f8d7da',
        color: message.type === 'success' ? '#155724' : '#721c24',
        borderRadius: 'var(--radius)'
      }
    }, message.text),

    React.createElement('form', { onSubmit: handleSave },
      // Language Preferences Section
      React.createElement('div', { className: 'card', style: { marginBottom: '16px' } },
        React.createElement('h2', { style: { fontSize: '18px', fontWeight: '600', marginBottom: '16px' } }, 
          'Language Preferences'
        ),

        React.createElement('div', { className: 'grid', style: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' } },
          React.createElement('div', null,
            React.createElement('label', { className: 'form-label' }, 'Native Language'),
            React.createElement('select', {
              className: 'form-control',
              value: settings.native_language || 'en',
              onChange: function(e) { handleChange('native_language', e.target.value); }
            },
              languages.map(function(lang) {
                return React.createElement('option', { key: lang.code, value: lang.code }, 
                  lang.name + ' (' + lang.native_name + ')'
                );
              })
            )
          ),
          React.createElement('div', null,
            React.createElement('label', { className: 'form-label' }, 'Translation Language'),
            React.createElement('select', {
              className: 'form-control',
              value: settings.target_language || 'th',
              onChange: function(e) { handleChange('target_language', e.target.value); }
            },
              languages.map(function(lang) {
                return React.createElement('option', { key: lang.code, value: lang.code }, 
                  lang.name + ' (' + lang.native_name + ')'
                );
              })
            )
          ),
          React.createElement('div', null,
            React.createElement('label', { className: 'form-label' }, 'Display Mode'),
            React.createElement('select', {
              className: 'form-control',
              value: settings.language_display_mode || 'dual',
              onChange: function(e) { handleChange('language_display_mode', e.target.value); }
            },
              React.createElement('option', { value: 'dual' }, 'Show both languages'),
              React.createElement('option', { value: 'native_only' }, 'Native only'),
              React.createElement('option', { value: 'target_only' }, 'Translation only')
            )
          )
        )
      ),

      // Default Offer Templates Section
      React.createElement('div', { className: 'card', style: { marginBottom: '16px' } },
        React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' } },
          React.createElement('h2', { style: { fontSize: '18px', fontWeight: '600' } }, 
            'Default Offer Templates'
          ),
          React.createElement('button', {
            type: 'button',
            className: 'btn btn-secondary',
            onClick: handleApplyToAll,
            disabled: saving
          }, 'Apply to All Offers')
        ),
        React.createElement('p', { className: 'text-secondary', style: { marginBottom: '16px', fontSize: '14px' } },
          'These templates will be used as defaults for new offers. You can customize each offer individually.'
        ),

        React.createElement('div', null,
          React.createElement('label', { className: 'form-label' }, 'Default Fine Print / Terms'),
          React.createElement('textarea', {
            className: 'form-control',
            rows: 4,
            value: settings.default_fine_print || '',
            onChange: function(e) { handleChange('default_fine_print', e.target.value); },
            placeholder: 'e.g., Reservation required. Valid for dine-in only. Cannot be combined with other offers.'
          })
        )
      ),

      // Default Contact Info Section
      React.createElement('div', { className: 'card', style: { marginBottom: '16px' } },
        React.createElement('h2', { style: { fontSize: '18px', fontWeight: '600', marginBottom: '16px' } }, 
          'Default Contact Info'
        ),
        React.createElement('p', { className: 'text-secondary', style: { marginBottom: '16px', fontSize: '14px' } },
          'Contact details shown on offers by default.'
        ),

        React.createElement('div', { style: { marginBottom: '16px' } },
          React.createElement('label', { className: 'form-label' }, 'Website URL'),
          React.createElement('input', {
            type: 'url',
            className: 'form-control',
            value: settings.default_website_url || '',
            onChange: function(e) { handleChange('default_website_url', e.target.value); },
            placeholder: 'https://your-business.com'
          })
        ),

        React.createElement('div', { className: 'grid', style: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' } },
          React.createElement('div', null,
            React.createElement('label', { className: 'form-label' }, 'Phone'),
            React.createElement('input', {
              type: 'text',
              className: 'form-control',
              value: settings.default_phone || '',
              onChange: function(e) { handleChange('default_phone', e.target.value); },
              placeholder: '+66 XX XXX XXXX'
            })
          ),
          React.createElement('div', null,
            React.createElement('label', { className: 'form-label' }, 'WhatsApp'),
            React.createElement('input', {
              type: 'text',
              className: 'form-control',
              value: settings.default_whatsapp || '',
              onChange: function(e) { handleChange('default_whatsapp', e.target.value); },
              placeholder: '+66 XX XXX XXXX'
            })
          ),
          React.createElement('div', null,
            React.createElement('label', { className: 'form-label' }, 'Line URL'),
            React.createElement('input', {
              type: 'text',
              className: 'form-control',
              value: settings.default_line_url || '',
              onChange: function(e) { handleChange('default_line_url', e.target.value); },
              placeholder: 'https://line.me/R/ti/p/@lineid'
            })
          )
        )
      ),

      // Save Button
      React.createElement('div', { style: { display: 'flex', justifyContent: 'flex-end' } },
        React.createElement('button', {
          type: 'submit',
          className: 'btn btn-primary',
          disabled: saving
        }, saving ? 'Saving...' : 'Save Settings')
      )
    )
  );
}

export default VendorSettings;
